<script>
  import { createEventDispatcher } from "svelte";
  import { moneyToFloat, floatToMoney } from "../helpers.js";
  import {
    Button,
    Col,
    Row,
    Card,
    CardBody,
    CardHeader,
    CardImg,
    CardSubtitle,
    CardText,
    CardTitle,
    CardFooter
  } from "sveltestrap";
  export let product = {};

  const dispatchEvent = createEventDispatcher();
  function addToCart() {
    dispatchEvent("addCart", product.name);
  }
</script>

<Card class="mb-3 h-100 border-secondary">
  <CardImg src={product.image} />
  <CardBody>
    <CardTitle>{product.name}</CardTitle>
    <CardText>{product.description}</CardText>
  </CardBody>
  <CardFooter>
    <h3>{floatToMoney(product.price, 'R$ ', 'pt-BR')}</h3>
    <Button color="primary" class="btn-block" outline on:click={addToCart}>
      <svg
        class="bi bi-plus"
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          d="M8 3.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4a.5.5 0 010-1h3.5V4a.5.5 0
          01.5-.5z"
          clip-rule="evenodd" />
        <path
          fill-rule="evenodd"
          d="M7.5 8a.5.5 0 01.5-.5h4a.5.5 0 010 1H8.5V12a.5.5 0 01-1 0V8z"
          clip-rule="evenodd" />
      </svg>
      Adicionar
    </Button>
  </CardFooter>
</Card>
